"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const tabStyle = (theme) => ({
    textTransform: 'none',
    backgroundColor: 'transparent',
    color: theme === 'dark' ? constants_1.color.white : '#404041',
    fontFamily: 'Poppins',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: '500',
    padding: 0,
    textAlign: 'center',
    marginRight: 13,
});
exports.default = {
    tabStyle,
};
